

































import { Prop, Component, Vue } from "vue-property-decorator";
import VIcon, { IconProps } from "../VIcon.vue";
import VBadgeTo from "@/components/VBadgeTo.vue";

@Component({
  components: {
    VIcon,
    VBadgeTo
  }
})
export default class ChatMessage extends Vue {
  @Prop() sender!: ChatMessageSenderProps;
  @Prop({ default: () => [] }) receivers!: ChatMessageReceiverProps[];
  @Prop() body!: string;
  @Prop() image!: string;
  @Prop() postedAt!: string;
}

export interface ChatMessageProps {
  sender: ChatMessageSenderProps;
  receivers: ChatMessageReceiverProps[];
  body: string;
  image: string;
  postedAt: string;
}

export interface ChatMessageSenderProps {
  group: string;
  name: string;
  icon: IconProps;
}

export interface ChatMessageReceiverProps {
  name: string;
  variant: string;
}
